import { useCallback, useEffect, useState } from "react";
import { Film, Clapperboard } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { useCustomer } from "@/context/CustomerContext";
import { api } from "@/lib/api";
import { cardCls } from "@/lib/labels";
import { LoyaltyCard } from "@/components/account/LoyaltyCard";
import { OrdersList } from "@/components/account/OrdersList";

const Stat = ({ Icon, label, value, testId, accent }) => (
  <div className={`${cardCls} p-6 ${accent || ""}`} data-testid={testId}>
    <Icon className="mb-3 h-7 w-7 text-[var(--km-lilac)]" />
    <p className="font-head text-sm text-purple-200/80">{label}</p>
    <p className="font-display text-4xl text-white">{value}</p>
  </div>
);

export default function AccountDashboard() {
  const { customer, setCustomer } = useCustomer();
  const [dash, setDash] = useState(null);
  const [tick, setTick] = useState(0);

  const load = useCallback(() => api.get("/customer/dashboard").then((r) => { setDash(r.data); setCustomer(r.data.customer); }).catch(() => {}), [setCustomer]);
  useEffect(() => {
    load();
    const t = setInterval(() => { load(); setTick((x) => x + 1); }, 20000);
    return () => clearInterval(t);
  }, [load]);

  if (!dash) return <p className="px-4 py-24 text-center text-purple-300/70" data-testid="account-loading">بنحمّل حسابك...</p>;

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" data-testid="account-dashboard">
      <Seo title="حسابي" noindex />
      <div className="mb-8">
        <p className="font-head text-[var(--km-cyan)]">أهلاً بيك</p>
        <h1 className="font-display text-4xl text-white sm:text-5xl" data-testid="account-brand-name">{customer.brand_name}</h1>
      </div>
      <div className="mb-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Stat Icon={Film} label="إجمالي الإعلانات" value={dash.stats.total_orders} testId="total-orders" />
        <Stat Icon={Clapperboard} label="إعلانات شغالين عليها" value={dash.stats.active_orders} testId="active-orders" />
        <LoyaltyCard loyalty={dash.loyalty} />
      </div>
      <h2 className="font-display mb-5 text-3xl text-white">أوردراتي</h2>
      <OrdersList tick={tick} />
    </div>
  );
}
